// removed by extract-text-webpack-plugin
module.exports = {"general":"general--5b62e","open":"open--90d5d"};